import i18n from "@/i18n";
import { useWidgetStore } from "@/state";
import { buildLoginUrl } from "@/core/actions";
import type { WidgetConfig } from "@/config";
import type { Lang, WidgetEnvironment } from "@/types";

let currentCfg: WidgetConfig | null = null;
let currentEnv: WidgetEnvironment | null = null;

export const setLanguageRuntimeContext = (
  cfg: WidgetConfig,
  env: WidgetEnvironment,
) => {
  currentCfg = cfg;
  currentEnv = env;
};

const normalizeLang = (lang: string): Lang => {
  const n = lang.substring(0, 2).toLowerCase();
  return n === "en" ? "en" : "el";
};

export const setWidgetLanguage = (lang: string): Lang => {
  const normalized = normalizeLang(lang);
  const st = useWidgetStore.getState().state;

  if (normalized !== i18n.language) {
    void i18n.changeLanguage(normalized);
    localStorage.setItem("i18nLang", normalized);
  }

  let nextLoginUrl = st.urls.loginUrl;
  if (currentCfg && currentEnv) {
    const nextCfg = { ...currentCfg, language: normalized };
    nextLoginUrl = buildLoginUrl(currentEnv, nextCfg);
    currentCfg = nextCfg;
  }

  useWidgetStore.getState().setState({
    ...st,
    language: normalized,
    urls: {
      ...st.urls,
      loginUrl: nextLoginUrl,
    },
  });

  window.dispatchEvent(
    new CustomEvent("telekomId:language", { detail: { lang: normalized } }),
  );
  return normalized;
};

export const getWidgetLanguage = (): Lang => {
  return useWidgetStore.getState().state.language ?? "el";
};
